import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { PERMISSIONS } from '../../constants';
import list from './PlanList';
import create from './PlanCreate';
import edit from './PlanEdit';

export default {
  list,
  create,
  edit,
  name: 'plans',
  permissions: [PERMISSIONS.PLAN],
  options: { label: 'Planos' },
  icon: CardMembershipIcon,
}
